import { ReadonlyRepositoryListService, Result } from '@softline/core';
import { computed, inject, Injectable, INJECTOR, Signal, signal } from '@angular/core';
import {
  BauprofiDataCarrierColumnsQuery,
  BauprofiDataCarrierColumnsRepository,
} from '../repositories/bauprofi-data-carrier-columns.repository';
import { DataCarrierColumns } from '../types/data-carrier-columns';
import { handleRequestError } from '@softline/application';

@Injectable()
export class BauprofiDataCarrierColumnsService extends ReadonlyRepositoryListService<
  DataCarrierColumns,
  Result<DataCarrierColumns[]>,
  BauprofiDataCarrierColumnsQuery | undefined
> {
  readonly #injector = inject(INJECTOR)
  readonly #dataCarrierColumnRepo = inject(BauprofiDataCarrierColumnsRepository)

  readonly configParams = signal<Signal<BauprofiDataCarrierColumnsQuery | undefined>>(
    signal(undefined)
  );

  override params = computed(() => {
    const format = this.configParams()()?.format;

    if(!format) return undefined

    return {
      format,
    };
  });

  constructor() {
    super(inject(BauprofiDataCarrierColumnsRepository));
  }

  setDataCarrierColumnsParams(
    configParams: Signal<BauprofiDataCarrierColumnsQuery | undefined>
  ) {
    this.configParams.set(configParams);
  }

  protected override getItems(
    result: Result<DataCarrierColumns[]> | null | undefined
  ): DataCarrierColumns[] {
    return result as any;
  }

  async updateSelectedFiles(body: DataCarrierColumns[]) {
    try {
      await this.#dataCarrierColumnRepo.updateSelectedFiles(body);
    } catch (error) {
      handleRequestError(error, this.#injector, {show:true});
    }
  }
}
